import { siteHeadersIds } from '../components/westfield-direct/layout/site-headers-ids'
import { universalHeaderId } from '@scentregroup/shared/constants'

export function getStickyHeaderHeight(): number {
  const headers =
    // site-headers takes into account the checkout progress bar in marketplace
    document.getElementById(siteHeadersIds) ||
    document.getElementById(universalHeaderId)

  const isHeaderSticky =
    headers && window.getComputedStyle(headers).position === 'sticky'

  return isHeaderSticky
    ? (headers?.getBoundingClientRect().height as number)
    : 0
}
